<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
  padding-bottom: 40px;
}
</style>
<template>
  <div class="coustomer-wrap">
    <el-dialog :title="type == 'create'?'创建项目':'编辑项目'"
      :visible.sync="dialogVisible"
      top="3vh"
      :close-on-click-modal="false" :close-on-press-escape="false"
      :destroy-on-close="true"
      width="600px">
      <el-form ref="formDataRef" :model="formData" label-width="90px"
        label-position="left"
        class="clearfix"
        size="medium">
        <el-form-item prop="name	" label="项目名称">
          <el-input v-model="formData.name" placeholder="请填写项目相关名称"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="leader_user_open_id" label="项目负责人">
          <el-select v-model="formData.leader_user_open_id" placeholder="请选择项目负责人"
            popper-class="ag-select-popper"
            :collapse-tags="true"
            filterable
            style="width: 100%;">
            <el-option
              v-for="userItem in users"
              :label="userItem.name"
              :key="userItem.open_id"
              :value="userItem.open_id">
              <div style="padding: 5px 0;">
                <span>{{ userItem.name }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item prop="company_id" label="相关企业">
          <el-select v-model="formData.company_id" placeholder="请选择相关企业"
            popper-class="ag-select-popper"
            :collapse-tags="true"
            style="width: 100%;">
            <el-option
              v-for="companyItem in companys"
              :label="companyItem.name"
              :key="companyItem.id"
              :value="companyItem.id">
              <div style="padding: 5px 0;">
                <span>{{ companyItem.name }}</span>
                <div style="line-height: 18px; color: #aaa;">
                  {{companyTypes.constMap.idMap[companyItem.type].name}}
                </div>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="contact_name" label="项目联系人">
          <el-input v-model="formData.contact_name" placeholder="请填写相关企业的项目联系人">
          </el-input>
        </el-form-item>
        <el-form-item prop="contact_phone" label="联系人电话">
          <el-input v-model="formData.contact_phone" placeholder="请填写相关企业的项目联系人电话">
          </el-input>
        </el-form-item>
        <el-form-item prop="contact_position" label="联系人职位">
          <el-input v-model="formData.contact_position" placeholder="请填写相关企业的项目联系人职位">
          </el-input>
        </el-form-item>
        <el-form-item prop="viewer" label="可见权限">
          <fc-org-select ref="condition-org" class="org-select-bar"
            :tabList="['dep&user']" v-model="initiatorDepUser" />
        </el-form-item>
        <el-form-item prop="remark" label="备注信息">
          <el-input v-model="formData.remark" type="textarea" placeholder="请填写备注信息">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button slot="reference" size="small" type="primary"
          :loading="btnIsLoading"
          @click="submitHandler">保存
        </el-button>
        <el-button slot="reference" size="small" @click="dialogVisible = false"
          style="margin-left: 10px;">取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { createProjects, editProject } from '@/api/project'
import { getCompanyList } from '@/api/company'
import { companyTypes } from '@/const'
import { getUsers, initUserAndDepartments } from '@/api/user'

let DEPARTMENT_MAP = {}
let USER_MAP = {}
const formDataDefault = {
  company_id: '',
  name: '',
  contact_name: '',
  contact_position: '',
  contact_phone: '',
  // leader_user_open_id: '',
  viewer: [],
  remark: ''
}
export default {
  name: 'craete-or-edit-customer',
  data() {
    return {
      projectId: '',
      companyTypes,
      initiatorDepUser: {
        'dep&user': [],
      },
      users: [],
      companys: [],
      formData: JSON.parse(JSON.stringify(formDataDefault)),
      dialogVisible: false,
      btnIsLoading: false,
      pageIsLoading: true,
      type: 'create'
    }
  },
  mounted() {
    this.$on('open', (projectForm) => {
      this.type = projectForm ? 'edit' : 'create'
      this.initiatorDepUser = {
        'dep&user': [],
      }
      this.formData = projectForm ? JSON.parse(JSON.stringify(projectForm)) : JSON.parse(JSON.stringify(formDataDefault))
      if (this.type === 'edit') {
        this.projectId = projectForm.id
        this.initPage(projectForm && projectForm.viewer)
      } else {
        this.initPage()
      }
      this.dialogVisible = true
    })
  },
  methods: {

    toInitiator(viewer) {
      console.log('viewer', viewer)
      const depAndUser = []
      viewer.forEach(item => {
        const res = {}
        if (item.type === 'DEPARTMENT') {
          const curItem = DEPARTMENT_MAP[item.value]
          res.deptId = curItem.open_department_id
          res.deptName = curItem.name
          res.parentDeptId = curItem.open_department_id
        }
        if (item.type === 'USER') {
          const curItem = USER_MAP[item.value]
          res.userId = item.value
          res.userName = curItem.name
          res.deptId = curItem.department_ids[0]
        }
        depAndUser.push(res)
      });
      return depAndUser
    },

    submitHandler() {
      this.btnIsLoading = true
      this[`${this.type}Action`]()
    },
    createAction() {
      this.formData.viewer = this.getViewData()
      createProjects(this.formData).then(res => {
        if (res.code != 0) throw new Error(res.message)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('refresh')
      }).catch(err => {
        console.log(err)
        this.$message.error(err.message);
      }).finally(() => {
        this.btnIsLoading = false
      })
    },

    editAction() {
      this.formData.viewer = this.getViewData()
      editProject(this.projectId, this.formData).then(res => {
        if (res.code != 0) throw new Error(res.message)
        this.$message.success('保存成功')
        this.dialogVisible = false
        this.$emit('refresh')
      }).catch(err => {
        this.$message.error(err.message);
      }).finally(() => {
        this.btnIsLoading = false
      })
    },

    getViewData() {
      const viewers = this.initiatorDepUser['dep&user']
      return viewers.map(item => {
        if (item.userId) {
          return {
            type: 'USER',
            value: item.userId
          }
        } else {
          return {
            type: 'DEPARTMENT',
            value: item.deptId
          }
        }
      })
    },

    async initPage(viewer) {
      this.pageIsLoading = true
      console.log('viewerviewer', viewer)
      if (viewer) {
        const depAndUser = await initUserAndDepartments()
        DEPARTMENT_MAP = depAndUser.DEPARTMENT_MAP
        USER_MAP = depAndUser.USER_MAP
        this.initiatorDepUser['dep&user'] = this.toInitiator([].concat(viewer))
      }
      const [userRes, companyRes] = await Promise.all([getUsers(), getCompanyList({ status: 2, page: 1, per_page: 10000, type: null })])
      console.log(' userRes?.data', userRes)
      this.users = userRes?.data || []
      this.companys = companyRes.data?.items || [];
      this.pageIsLoading = false
    }
  },
}
</script>